export default 'https://oubelectronics.pythonanywhere.com/';
